import React, { useEffect, useState } from "react";
import "./procedure.css";
import api from "../../service/caller";
import { format } from "date-fns";

export default function ProcedureAdministration({ patientId, onMedicationChange , medicationRows: propRows }) {
  const [UserData, setUserData] = useState();

  const [localRows, setLocalRows] = useState([
    {
      id: Date.now(), 
      name: "",
      date: "",
      notes: "",
      price:""
    }
  ]);

  const medicationRows = propRows ?? localRows;
  const setMedicationRows = propRows ? onMedicationChange : setLocalRows;

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        // toast.error("Failed to fetch data");
      }
    };
    const fetchTraitment = async () => {
      try {
        const response = await api.get(`api/treatment-plans/get-plan/${patientId._id}`);
        if (response.data.data.length > 0) {
          console.log("pass");
          // Ensure each row has a unique id
          const medicationsWithIds = response.data.data[0].procedures.map(med => ({
            ...med,
            id: med._id || Date.now() + Math.random()
          }));
          setMedicationRows(medicationsWithIds);
        }
      } catch (error) {
        // toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
    fetchTraitment();
  }, [patientId]);

  useEffect(() => {
    // Pass medicationRows data to parent component whenever it changes
    onMedicationChange(medicationRows);
  }, [medicationRows, onMedicationChange]);

  const addNewRow = () => {
    // Create a new empty row with a unique ID
    const newRow = {
      id: Date.now(), // Generate unique id using timestamp
      name: "",
      date: "",
      notes: "",
      price:""
    };
    setMedicationRows([...medicationRows, newRow]);
  };

  const removeRow = (id) => {
    // Prevent removing the last row if it's the only one
    if (medicationRows.length <= 1) {
      return;
    }
    
    setMedicationRows((prevRows) => 
      prevRows.filter((row) => row.id !== id && row._id !== id)
    );
  };

  const handleChange = (id, field, value) => {
    setMedicationRows((prevRows) =>
      prevRows.map((row) =>
        (row.id === id || row._id === id) ? { ...row, [field]: value } : row
      )
    );
  };

  return (
    <div className="treatment-container">
  {/* Liste des lignes de saisie */}
  <div className="treatment-administration">
    {medicationRows.map((row, index) => (
      <div key={row.id || row._id} className="treatment-row">
        <div className="treatment-field">
          <label className="treatment-label">Name</label>
          <input
            type="text"
            value={row.name || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "name", e.target.value)
            }
            className="treatment-input"
          />
        </div>

        <div className="treatment-field">
          <label className="treatment-label">Date</label>
          <input
            type="date"
            value={row?.date ? format(new Date(row?.date), "yyyy-MM-dd") : ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "date", e.target.value)
            }
            className="treatment-input treatment-input-quantity"
          />
        </div>

        <div className="treatment-field">
          <label className="treatment-label">Note</label>
          <input
            type="text"
            value={row.notes || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "notes", e.target.value)
            }
            className="treatment-input"
          />
        </div>

        <div className="treatment-field">
          <label className="treatment-label">Price</label>
          <input
            type="number"
            value={row.price || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "price", e.target.value)
            }
            className="treatment-input treatment-input-date"
          />
        </div>

        {/* Buttons container for add and remove */}
        <div className="treatment-buttons">
          {/* Remove button */}
          <button
            onClick={() => removeRow(row.id || row._id)}
            className="treatment-add-btn"
            disabled={medicationRows.length <= 1}
            title={medicationRows.length <= 1 ? "Cannot remove the last treatment" : "Remove this treatment"}
          >
            -
          </button>
          
          {/* Add button only on the last row */}
          {index === medicationRows.length - 1 && (
            <button
              onClick={addNewRow}
              className="treatment-add-btn"
            >
              +
            </button>
          )}
        </div>
      </div>
    ))}
  </div>
</div>
  );
}